import { Box, Button, styled, Typography } from '@mui/material'
import { ForwardIcon } from '$common/icons'
import { ReplyIcon } from '$common/icons/reply'
import { t } from '$i18n'
import {
  SELECT_BAR_HEIGHT,
  SEND_FIELD_BORDER_TOP_COLOR,
} from '$comp/_app/components/chat/components/conf'
import { showUnableToShowContextMenuSnackbar } from '$comp/snackbars'

const Root = styled(Box)`
  height: ${SELECT_BAR_HEIGHT}px;
  padding: 0 8px;
  display: flex;
  border-top: 1px solid ${SEND_FIELD_BORDER_TOP_COLOR};
  justify-content: space-between;
  align-items: center;
  background-color: white;
  z-index: 1;
`
const StyledButton = styled(Button)`
  height: 40px;
  /* @noflip */
  border-radius: 8px;
  .MuiButton-startIcon {
    > svg {
      font-size: 24px;
    }
  }
  .MuiButton-endIcon {
    margin-right: 8px;
    margin-left: 0;
    > svg {
      font-size: 24px;
    }
  }
  &.Mui-disabled {
    opacity: 0.5;
  }
`

export function SelectBar({
  onReply,
  onForward,
  protectContent,
  arePermissionsStale,
  isGroup,
}: {
  onForward: (() => Promise<void>) | null
  onReply: (() => void) | null
  arePermissionsStale?: boolean
  protectContent?: boolean
  isGroup: boolean
}) {
  return (
    <Root dir="rtl">
      {onForward && (
        <StyledButton
          disabled={arePermissionsStale}
          sx={{ opacity: protectContent ? 0.5 : 1 }}
          startIcon={<ForwardIcon sx={{ color: 'secondary.main' }} />}
          onClick={
            protectContent
              ? () => showUnableToShowContextMenuSnackbar(isGroup)
              : onForward
          }
        >
          <Typography color="secondary.main" variant="subtitle3">
            {t('chat.forward')}
          </Typography>
        </StyledButton>
      )}
      {onReply && (
        <StyledButton
          disabled={arePermissionsStale}
          endIcon={<ReplyIcon />}
          onClick={onReply}
        >
          <Typography color="secondary.main" variant="subtitle3">
            {t('contextMenu.reply')}
          </Typography>
        </StyledButton>
      )}
    </Root>
  )
}
